<template>
  <h3>Anteil der Leistungsbereiche</h3>
  <div class="inner">
    <div>{{ chartCenterText }} Mio.</div>
  </div>
  <div style="position:relative;z-index:5">
  <Doughnut
    :chart-options="chartOptions"
    :chart-data="chartData"
    chart-id="anteilLeistChart"
  />
  </div>
  
  
</template>

<script>
import { ref, watch } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import { colors } from "@/utils/config";
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

Chart.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  annotationPlugin,
  ArcElement
);

Chart.defaults.font.family =
  'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif';
Chart.defaults.font.size = 14;

import { Doughnut, Bar } from "vue-chartjs";
import { toolTipDefault } from "@/utils/settings";

export default {
  name: "AnteilLeist",
  components: { Doughnut, Bar },
  props: ["data", "options", "id", "quartal", "inPrint", "inDownload"],
  setup(props) {
    const chartData = ref();
    const chartCenterText = ref();
    let rowLabels = [
      "EGV",
      "MGV Unbudgetiert",
      "MGV budgetiert",
      "SKT",
      "TSVG",
    ];

    let dataSet;

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: 40
      },
      plugins: {
        autocolors: false,
        legend: {
          onClick: (e) => e.stopPropagation(),
          position: "bottom",
          labels: {
            boxWidth: 15,
            boxHeight: 15,
            usePointStyle: true,
            padding: 20
          },
          title: {
            padding: 15,
            display: true,
          }
        },
        tooltip: {
          ...toolTipDefault,
          callbacks: {
            title: function (context) {         
              return rowLabels[context[0].dataIndex];
            },
            label: function (context) {
              return (
                (Math.round(dataSet[context.dataIndex] * 10) / 10).toLocaleString(
                "de-DE"
              ) + "%"
              );
            },
          },
        },
        datalabels: {
          color: "#000",
          offset: (context) => {
            if (context.dataIndex % 2 == 0) {
              return 55;
            }
            return 73;
          },
          padding: 30,
          align: "end",
          anchor: "start",
          clamp: false,
          font: {
            size: 13,
            family:
              'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
            weight: 200,
          },
          formatter: (value, context) => {
            return (
              (Math.round(dataSet[context.dataIndex] * 10) / 10).toLocaleString(
                "de-DE"
              ) + "%"
            );
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        y: {
          grid: {
            display: false,
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    };

    const updateDataset = () => {
      const dataKeyed = {};
      const displayDataKeyed = {};

      Object.values(props.data.auf).forEach((row) => {
        dataKeyed[row[2].replace(" ", "")] = row[8];
        displayDataKeyed[row[2].replace(" ", "")] = Math.max(row[8], 0.5);
      });

      dataSet = [
        dataKeyed["EGV"],
        dataKeyed["MGVunbudgetiert"],
        dataKeyed["MGVbudgetiert"],
        dataKeyed["SKT"],
        dataKeyed["TSVG"],
      ];

      const displayDataSet = [
        displayDataKeyed["EGV"],
        displayDataKeyed["MGVunbudgetiert"],
        displayDataKeyed["MGVbudgetiert"],
        displayDataKeyed["SKT"],
        displayDataKeyed["TSVG"],
      ];

      chartData.value = {
        datasets: [
          {
            data: displayDataSet,
            backgroundColor: colors.anteilLeist,
            //         label: "EGV",
            borderWidth: 0,
          },
        ],
        labels: rowLabels,
      };

      chartCenterText.value = (props.data.rlv[0][2] / 1000000).toLocaleString(
        "de-DE",
        {
          maximumFractionDigits: 2,
        }
      );
    };

    updateDataset();

    watch(
      () => props.data.auf,
      (val, prevVal) => {
        updateDataset();
      }
    );

    return {
      chartOptions,
      chartData,
      chartCenterText,
    };
  },
};
</script>
